import { render, staticRenderFns } from "./SpTabContainer.vue?vue&type=template&id=bbc4920e&scoped=true&"
import script from "./SpTabContainer.vue?vue&type=script&lang=js&"
export * from "./SpTabContainer.vue?vue&type=script&lang=js&"
import style0 from "./SpTabContainer.vue?vue&type=style&index=0&id=bbc4920e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4920e",
  null
  
)

export default component.exports